/**
 * MimeeQ Cart Integration
 * Properly integrates MimeeQ cart additions with theme's cart system
 */

(function () {
  "use strict";

  const mimeeqCartIntegration = {
    init() {
      this.interceptFetchRequests();
    },

    interceptFetchRequests() {
      const originalFetch = window.fetch;
      const self = this;

      window.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args);

        if (
          typeof args[0] === "string" &&
          args[0].includes("/apps/mimeeqApp/add-to-cart") &&
          response.ok
        ) {
          setTimeout(() => self.updateCart(), 1000);
        }

        return response;
      };
    },

    updateCart() {
      if (window.SLIDECART_UPDATE && window.SLIDECART_OPEN) {
        window.SLIDECART_UPDATE();
        
        setTimeout(() => {
          window.mimeeqBundleHandler?.detectAndRenderBundles();
        }, 1500);
        
        if (theme.settings.afterAddToCart === "drawer") {
          setTimeout(() => {
            window.SLIDECART_OPEN();
            setTimeout(() => {
              window.mimeeqBundleHandler?.detectAndRenderBundles();
            }, 800);
          }, 1200);
        }
      } else {
        document.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
        setTimeout(() => {
          window.mimeeqBundleHandler?.detectAndRenderBundles();
        }, 1000);
        
        if (theme.settings.afterAddToCart === "drawer") {
          setTimeout(() => {
            document.querySelector(".js-cart-drawer")?.open();
          }, 1000);
        }
      }
    },
  };

  // Initialize
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () =>
      mimeeqCartIntegration.init()
    );
  } else {
    mimeeqCartIntegration.init();
  }

  window.mimeeqCartIntegration = mimeeqCartIntegration;
})();
